// extracted by mini-css-extract-plugin
export default {"entityVisibility":"EntityVisibilityIcon_entityVisibility__TnusO","isCompanyWide":"EntityVisibilityIcon_isCompanyWide__A7RmR","isOneOff":"EntityVisibilityIcon_isOneOff__JeEuY"};